import gridClientBase from "../../components/gridClientComponentBase";
import { mapGetters } from "vuex";
import ApiService from "../../services/api";
import { bus } from "../../main";

export default {
	extends: gridClientBase,
	components: {},
	data: function() {
		return {
			items: [],
			reportItems: [
				{
					id: "REPORT_UTILIZATION",
					name: "utilizzo",
					scope: "exp_200"
				},
				{
					id: "REPORT_TRIPS",
					name: "viaggi",
					scope: "exp_210"
				},
				{
					id: "REPORT_JOURNEY",
					name: "percorrenza",
					scope: "exp_220"
				},
				{
					id: "REPORT_BEHAVIORS",
					name: "comportamento conducenti",
					scope: "exp_230"
				},
				{
					id: "REPORT_ALARMS",
					name: "allarmi",
					scope: "exp_240"
				},
				{
					id: "REPORT_DIAGNOSTIC",
					name: "diagnostica",
					scope: "exp_250"
				},
				{
					id: "REPORT_TRIP_EVENTS",
					name: "Report analitico giornaliero",
					scope: "exp_260"
				},
				{
					id: "REPORT_LAST_DIAGNOSTIC",
					name: "Ultime rilevazioni diagnostica/allarmi",
					scope: "exp_270"
				}
			]
		};
	},

	created() {
		//this.sort = [{ field: "name", dir: "asc" }];

		this.hasSelectedMode = true;
		this.$on("selected-row", this.onSelectedRow.bind(this));

		this.getConfig();
	},
	beforeDestroy() {},
	methods: {
		getConfig() {
			var self = this;
			bus.$emit("show-spinner-loading");
			ApiService.getViewConfig("fleerun_report").then(res => {
				self.setReportNames(res);
				self.setReportVisibility();

				bus.$emit("hide-spinner-loading");
			});
		},
		setReportNames(names) {
			if (names && names.length > 0) {
				this.reportItems.forEach(rpt => {
					var name = names.find(item => {
						return item.id == parseInt(rpt.scope.replace("exp_", ""));
					});

					if (name) {
						rpt.name = name.name;
					}
				});
			}
		},
		setReportVisibility() {
			//set visible report from scopes
			if (this.scopes && this.scopes.length > 0) {
				var self = this;
				this.reportItems.forEach(rpt => {
					var hasScope = self.scopes.some(scp => {
						return scp && scp.toLowerCase() == rpt.scope.toLowerCase();
					});

					if (hasScope) {
						self.items.push(rpt);
					}
				});
			} else {
				//no report visible
				this.items = [];
			}
		},
		onSelectedRow(dataItem) {
			this.goToDetail(dataItem.id);
		},
		goToDetail(id) {
			this.$router.push({
				name: id
			});
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["scopes"]),
		columns: function() {
			return [
				{
					cell: "myDetailCellTemplate",
					width: "45px",
					sortable: false,
					headerCell: "myHeaderTemplate"
				},
				{
					field: "name",
					title: "nome",
					cell: "myCellTemplate",
					headerCell: "myHeaderTemplate",
					filterable: false
				}
			];
		}
	}
};
